export default "/images/75ad14dcfea03fcaf122da893ad48590.avif";